<!-- 监控声音操作 -->
<template>
  <div id="app"
       v-loading="loading"
       element-loading-text="拼命加载中"
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)"
       class="bg-background">
    <router-view/>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import eventBus from '@/utils/eventBus.js'
export default {
  data () {
    return {
      loading: true,
      requestHeader: null,
      token: null
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created () {
    this.init()
  },
  mounted () {
    setTimeout(() => {
      window.parent.postMessage({
        type: 'ACCESS_SUCCESSFUL', // 访问成功
        data: {}
      }, '*')
    }, 1000)
    // this.loginByToken({
    //   requestHeader: 'http://192.168.0.176:31180', // 请求头地址：https://www.XXXX.com/
    //   token: 'eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkIjoxNzczMzcwMjgwNzMyLCJpZCI6IjExNTc3MjQwMjI1Nzk5MzMxODQiLCJ0eXBlIjoxLCJleHAiOjE3NzU5NjIyODAsImFjY291bnQiOiJ4eHgifQ.KkUDDFEi_PNC4qYy5PevuzEcoYfAxWo-V6RZEcdIJ9zo5aA2zKTw9nKjDctmawulQ9szo0mvCNje9lM8w6ZpbA' // 平台token
    // })
    window.addEventListener('message', (event) => {
      const { type, data } = event.data
      if (type === 'REDIRECT_PAGE') {
        if (data.path) {
          const path = this.$router.currentRoute.path || ''
          if (path.includes(data.path)) {
            eventBus.emit(`${data.path}-${data.method}`, data.parameter)
          } else {
            this.$router.push({ path: `/${data.path}`, query: data })
          }
        }
      } else if (type === 'LOGIN_PAGE') {
        this.loginByToken(data)
      }
    })
    // 1、 断网重新链接
    window.addEventListener('online', () => {
      console.log('网络恢复,刷新页面')
      location.reload()
    })
    window.addEventListener('offline', () => {
      console.log('网络断开')
    })
    // 2、关闭页面时发送异步请求
    window.addEventListener('beforeunload', () => {
      this.closeByClientId()
    })
    // 3、 刷新页面后关闭房间
    window.onunload = () => {
      this.onunloadFn()
      return ''
    }
  },
  methods: {
    /* 获取路由指定参数 (兼容 hash 路由 / URL 编码值) */
    getParameter (name) {
      const href = window.location.href
      const queryIndex = href.indexOf('?')
      if (queryIndex === -1) return
      const params = new URLSearchParams(href.slice(queryIndex + 1))
      return params.get(name) ?? undefined
    },
    init () {
      // http://192.168.0.222:20001/#/monitoring?requestHeader=http%3A%2F%2F192.168.0.176%3A31180&token=eyJhbGciOiJIUzUxMiJ9.eyJjcmVhdGVkIjoxNzgyMTgxMjI0MDkwLCJpZCI6IjExNTc3MjM4ODY0OTE1NDU2MDAiLCJ0eXBlIjoxLCJleHAiOjE3ODQ3NzMyMjQsImFjY291bnQiOiJ4eHgifQ.0JIHsRW6D1W7bv-wqwqePYnQNVoviRZtQK2ia3mump7gy9FHUBPgloF7EwRPtDxbXVIpX5TaDX8raxMeDlg0rw&deviceIds=1111,222
      this.requestHeader = this.getParameter('requestHeader')
      this.token = this.getParameter('token')
      console.log('requestHeader', this.requestHeader, this.token)
      if (this.requestHeader && this.token) {
        this.loginByToken({
          requestHeader: this.requestHeader, // 请求头地址：https://www.XXXX.com/
          token: this.token
        })
      }
    },
    // 2、关闭页面时发送异步请求
    closeByClientId () {
      this.$sdk.closeByClientId()
      // 阻塞进程保证请求发送成功
      for (let i = 1; i < 10000; i++) {
        for (let m = 1; m < 10000; m++) {
          continue
        }
      }
    },
    // 3、 刷新页面后关闭房间
    onunloadFn () {
      this.$sdk.onunloadOperation()
    },
    // 4、获取用户信息并监听mq断开
    async loginByToken (params, thirdPartyToken) {
      this.$sdk.setRequestHeader(`${params.requestHeader}`)
      let token = params.token
      if (thirdPartyToken) {
        const res = await this.$componentsApi.login.ssoToken({
          token: params.token
        })
        token = res.data
      }
      this.loading = true
      const json = {
        requestHeader: params.requestHeader, // 请求头地址：https://www.XXXX.com/
        token, // 平台token
        event: {
          // mqtt 断开通知
          disconnectionNotify: (e) => {
            // mqtt 断开重新链接tong
            // const list = this.$sdk.obtainAllClientIdList()
            window.parent.postMessage({
              type: 'MQTT_LINK_ERROR', // 访问成功
              data: {}
            }, '*')
            // if (list && list.length) {
            //   console.log('004')
            //   // 有正在音视频房间的功能，需要刷新页面，使用 sdkReconnect 房间流程也不会恢复
            //   location.reload()
            // } else {
            //   console.log('003')
            //   // 可直接发起重新连接
            //   this.$sdk.sdkReconnect()
            // }
          }
        }
      }
      this.$sdk.loginByToken(json, this.$sdk, this.$business).then((res) => {
        console.log('成功返回用户信息', res)
        this.$store.commit('setUserInfo', res.data)
        this.bulkSubscriptionDevice()
      }).catch((res) => {
        console.log('失败返回错误内容', res)
      })
    },
    // 5、批量订阅设备 (为了及时通知设备状态)
    async bulkSubscriptionDevice () {
      const res = await this.$componentsApi.login.userSubDeviceMqLink()
      if (res && res.code === 200) {
        this.$business.userSubscribeDevice(this.userInfo.id)
        this.loading = false
        window.parent.postMessage({
          type: 'MQTT_LINK_SUCCESSFUL',
          data: this.userInfo
        }, '*')
      }
    }
  }
}
</script>
